import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M19.088 16.876a.75.75 0 1 1 1.5 0 5.933 5.933 0 0 1-5.934 5.933.75.75 0 1 1 0-1.5 4.434 4.434 0 0 0 4.434-4.433m-10.667-2.04a3.03 3.03 0 0 1 2.725 1.706h2.066c.713 0 1.097-.477 1.097-.845v-3.386l-.004-.158H2.7a.75.75 0 1 1 0-1.5h3.123l-.977-3.265H2.77a.75.75 0 1 1 0-1.5h9.06l.254.012c.45-.751 1.039-1.525 1.982-1.854l.097-.026 2.992-.612a3.7 3.7 0 0 1 1.304-.034l2.806.419a.75.75 0 0 1 .631.853.75.75 0 0 1-.853.631l-2.806-.419a2.2 2.2 0 0 0-.781.021l-2.93.598c-.399.152-.716.497-1.074 1.068l.054.052c.272.286.485.641.664.97l.169.316.029.061 1.067 2.521c.248.585.375 1.214.375 1.85v3.386c0 1.395-1.27 2.345-2.597 2.345H11.45a3.033 3.033 0 0 1-6.046.124H2.7a.75.75 0 1 1 0-1.5h2.937a3.03 3.03 0 0 1 2.783-1.83zm8.337 2.163a.75.75 0 1 1 1.5 0 3.48 3.48 0 0 1-3.301 3.476l-.179.005-.077-.004a.75.75 0 0 1 .077-1.496l.202-.011a1.98 1.98 0 0 0 1.777-1.97zm-8.337-.663a1.533 1.533 0 1 0 .002 3.066 1.533 1.533 0 0 0-.002-3.066M7.39 10.653h6.495l-.887-2.094c-.241-.451-.394-.735-.58-.931-.144-.151-.297-.24-.589-.24H6.413z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const RearHatchSensorIcon = ForwardRef;